import React, { Component } from 'react';
import { connect } from 'react-redux';
import Translator from './../../requests/apa/Translator';
import Asset from "./../../requests/apa/Asset";
import { Start, Add, Select, Admin, Edit, Complete } from './../../components/Profile';
import { showModal, AAF_MODAL_ERROR, MODAL_GENERIC } from '../../actions/modal';
import { setProfileData, setProfileMembers } from '../../reducers/profile';
import { setMetricsEvent } from '../../actions/metrics';
import { fetchProfileRead } from '../../actions/profile';
import { getAvatar, createProfile, deleteProfile, readProfile, updateProfile, login } from '../../requests/loader';
import { receiveIsLoggedIn, setLastTouchProfile } from '../../reducers/user';
import * as constant from './../../components/Profile/constants';
import Spinner from '../../components/Spinner';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import DeviceStorage from './../../components/DeviceStorage/DeviceStorage';
import store from '../../store';
import { ALERT_ACTION_IPTELMEX } from '../../containers/App/constants';
import settings from '../../devices/all/settings';
import './profile.scss';

import utilsIsSticky from '../../utils/user/IsSticky';
import BlockedChannels from "../../utils/BlockedChannels";
import channelBlockedUtil from "../../utils/ChannelBlockedUtil";
import Utils from '../../utils/Utils';
import ProfileReadCache from '../../AAF/LoaderExp/ProfileReadCache';
import LoadFav from '../../AAF/LoaderExp/LoadFav';
import NewRelic from 'src/utils/trackers/NewRelic';

class Profile extends Component {

  constructor(props) {

    super(props);

    this.state = {
      action: constant.START,
      data: [],
      avatars: {
        items: [],
        currentPage: 1,
        default: null
      },
      formFrom: '',
      isLoading: true,
      selectedImage: '',
      values: {
        firstName: '',
        userImage: '',
      },
      defaultFocus: true,
      errors: {
        firstName: '',
        userImage: '',
      },
      currentKey: '',
    };

    this.bindFunction();
    this.finishLanding = this.props.finishLanding;
  }

  bindFunction() {
    this.getItems = this.getItems.bind(this);
    this.setAction = this.setAction.bind(this);
    this.getComponent = this.getComponent.bind(this);
    this.readProfileComplete = this.readProfileComplete.bind(this);
    this.readProfileError = this.readProfileError.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.setCurrentKey = this.setCurrentKey.bind(this);
    this.setTextValue = this.setTextValue.bind(this);
    this.setImageValue = this.setImageValue.bind(this);
    this.setSelectedImage = this.setSelectedImage.bind(this);
    this.setIsLoading = this.setIsLoading.bind(this);
    this.showWarning = this.showWarning.bind(this);
    this.updateCurrentPage = this.updateCurrentPage.bind(this);
    this.onFieldError = this.onFieldError.bind(this);
    this.login = this.login.bind(this);
    this.createProfile = this.createProfile.bind(this);
    this.sendMetricProfile = this.sendMetricProfile.bind(this);
    this.stickySuccess.bind(this);
    this.updateBlockedChannels.bind(this);

  }

  componentDidMount() {
    window.SpatialNavigation.makeFocusable();
    this.readProfile();
    this.readAvatars();
    //this.sendDimension();

    if (this.props.match && this.props.match.params && this.props.match.params.name === 'admin') {
      this.setAction(constant.ADMIN_PROFILE)
    }
    if (this.state.action == constant.START)
      Utils.addPageAction('perfiles');
  }

  setCurrentKey(key = '') {
    if (this.state.currentKey !== key) {
      this.setState({ currentKey: key });
    }
  }

  async readProfile() {

    const user = store.getState().user;

    store.dispatch(fetchProfileRead({
      gamification_id: user.gamification_id,
      user_token: user.user_token,
    }, this.readProfileComplete, this.readProfileError));
  }

  readProfileComplete(members) {
    if (typeof members === 'object') {
      this.setState({ data: members });
    }
    this.setIsLoading(false);
    ProfileReadCache.setforceUpdateReadProfile(true);
    if (!ProfileReadCache.getVerifyRead() && !ProfileReadCache.IsfirstTimeToLoad()) {
      ProfileReadCache.setVerifyRead(true);
      this.readProfile();
    } else {
      ProfileReadCache.setEnableClick(true);
    }
  }

  readProfileError(completeError) {
    ProfileReadCache.setEnableClick(true);
    this.showError(completeError && completeError.errors)
  }


  async readAvatars() {
    if (this.state.avatars.items.length === 0) {
      const result = await getAvatar({});
      const defaultAvatar = result.avatars.filter((avatar) => avatar.default == true);
      let newState = this.state;
      newState.avatars.items = result.avatars;
      newState.avatars.default = defaultAvatar[0] && defaultAvatar[0].user_image ? defaultAvatar[0].user_image : null;
      this.setState(newState);
    }
  }

  login(params) {
    this.setIsLoading(true);
    login(params).then((resp) => {
      if (resp && resp.status == '0') {
        this.successLogin = this.successLogin.bind(this);
        this.successLogin(resp.response);
        Utils.setCustomAttribute();
      }
    }).catch((err) => {
      this.failLogin(err);
    });
  }

  async successLogin(response) {
    store.dispatch(receiveIsLoggedIn(response));
    const region = DeviceStorage.getItem('region');
    const pushSession = Utils.getApaMetadataKey('sticky_session', '{"push_session":false,"user_id":false}', 'push_session');


    if (pushSession) {
      await utilsIsSticky.getPushSession(this.stickySuccess.bind(this), response);
    }
    else {
      this.stickySuccess(null, response).bind(this);
    }
  }


  stickySuccess(stickyResponse, response) {
    const region = DeviceStorage.getItem('region');
    DeviceStorage.setItem('user_hash', response.session_userhash);
    if (response.user_id) {
      DeviceStorage.setItem('user_id', response.user_id);
      NewRelic.setUserId(response.user_id);
    }
    if (typeof this.finishLanding === 'function') {
      this.finishLanding(() => {
        this.props.history.push('/');
        const { validEmail = true } = response;
        if (!validEmail) {
          setTimeout(() => {
            const detail = {
              isAlertVisible: true,
              alertAction: ALERT_ACTION_IPTELMEX
            };
            document.dispatchEvent(
              new CustomEvent(settings.show_head_band, { detail })
            );
          }, 200);
        };
        LoadFav.start();
      });
    }
  }


  updateBlockedChannels() {
    let blockedChannelsList = new BlockedChannels();
    blockedChannelsList.checkBlockedChannels().then((response) => {
      channelBlockedUtil.set('blockedChannels', response);
    });
  }

  failLogin(response) {

    this.showError(response.errors);

  }

  showError(errors) {
    const modal = {
      modalType: AAF_MODAL_ERROR,
      modalProps: {
        callback: () => {
          this.setIsLoading(false);
        },
        content: errors
      }
    };
    store.dispatch(showModal(modal));
  }


  async createProfile(profile) {
    this.setIsLoading(true);
    const result = await createProfile(profile);
    if (result && result.response && result.response.data) {
      ProfileReadCache.setReadProfileStorage(result.response);
      const data = result.response.data

      if (result.response.lasttouch && result.response.lasttouch.profile) { // set new lasttouch Profile in redux
        const lastTouchProfile = result.response.lasttouch.profile;
        store.dispatch(setLastTouchProfile(lastTouchProfile));
      }

      this.setState({ data });
      //Fix STV-7594 Actualiza en redux el nuevo registro
      store.dispatch(setProfileMembers(data.members || []));
    }
    else {
      this.showError(result && result.completeError && result.completeError.errors);
    }

    return result;
  }

  async deleteProfile(profile) {
    this.setIsLoading(true);

    const result = await deleteProfile(profile);
    if (result && result.response && result.response.lasttouch && result.response.lasttouch.profile) { // set new lasttouch Profile in redux
      const lastTouchProfile = result.response.lasttouch.profile;
      store.dispatch(setLastTouchProfile(lastTouchProfile));
    }

    if (result && result.response && result.response.data) {
      const data = result.response.data
      ProfileReadCache.setReadProfileStorage(result.response);
      this.setState({ data });

      this.sendMetricProfile({
        event: constant.METRIC_EVENT,
        category: constant.METRIC_CATEGORY_START,
        action: constant.METRIC_ACTION_PROFILE,
        label: constant.METRIC_LABEL_DELETEPROFILE,
      });
      //Fix STV-7594 Actualiza en redux el nuevo registro
      store.dispatch(setProfileMembers(data.members || []));
      this.setAction(constant.ADMIN_PROFILE);
    }
    else {
      this.showError(result && result.completeError && result.completeError.errors);
    }
  }

  async updateProfile(profile) {

    this.setIsLoading(true);

    const user = store.getState().user;
    const params = Object.assign({}, profile, { user_token: user.user_token });

    let result = await updateProfile(params);
    if (result && result.response && result.response.lasttouch && result.response.lasttouch.profile) { // set new lasttouch Profile in redux
      const lastTouchProfile = result.response.lasttouch.profile;
      store.dispatch(setLastTouchProfile(lastTouchProfile));
    }

    if (result && result.status == '0') {
      this.updateProfileState(result);
      this.setAction(constant.ADMIN_PROFILE);
    } else {
      this.showError(result && result.completeError && result.completeError.errors);
    }

    this.setIsLoading(false);
  }


  updateProfileState(resp) {

    let newState = this.state;
    let members = (newState.data && newState.data.members) || [];

    var foundIndex = members.findIndex(member => member.gamification_id == resp.response.gamification_id);

    if (foundIndex > -1) {
      members[foundIndex].user_image = resp.response.user_image;
      members[foundIndex].username = resp.response.username;
      members[foundIndex].admin = resp.response.admin;
      members[foundIndex].change_name = resp.response.change_name;
      members[foundIndex].gamification_id = resp.response.gamification_id;
      members[foundIndex].partnerUserId = resp.response.partnerUserId;
      members[foundIndex].rol = resp.response.rol;
      members[foundIndex].user_hash = resp.response.user_hash;
    }

    newState.data.members = members;
    newState && newState.data && newState.data.members && ProfileReadCache.updateStorageByItems(newState.data.members);
    this.setState(newState);
  }

  setAction(action, editItem) {

    let newState = this.state;

    switch (action) {
      case constant.START:
        newState.isLoading = false;
        newState.values.firstName = '';
        newState.values.userImage = '';
        newState.errors.firstName = '';
        newState.errors.userImage = '';
        newState.defaultFocus = true;
        break;
      case constant.ADD_PROFILE:
        if (newState.action !== constant.SELECT_PROFILE) {
          newState.values.firstName = '';
        }
        newState.values.userImage = this.state.avatars.default;
        newState.formFrom = constant.ADD_PROFILE;
        this.sendMetricProfile({
          event: constant.METRIC_EVENT,
          category: constant.METRIC_CATEGORY_START,
          action: constant.METRIC_ACTION_PROFILE,
          label: constant.METRIC_LABEL_ADD,
        });
        break;
      case constant.ADMIN_PROFILE:
        if (!ProfileReadCache.getEnableClick()) {
          return;
        }
        newState.isLoading = false;
        this.sendMetricProfile({
          event: constant.METRIC_EVENT,
          category: constant.METRIC_CATEGORY_START,
          action: constant.METRIC_ACTION_PROFILE,
          label: constant.METRIC_LABEL_ADMINPROFILE,
        });
        break;
      case constant.COMPLETE_PROFILE:
      case constant.EDIT_PROFILE:
        if (editItem) {
          if (newState.action !== constant.SELECT_PROFILE) {
            newState.values.firstName = editItem.username;
          }
          newState.values.userImage = editItem.user_image;
          newState.editData = editItem;
        }
        newState.formFrom = action;
        break;
      case constant.SELECT_PROFILE:
        newState.defaultFocus = true;
        newState.avatars.currentPage = 1;
        newState.selectedImage = '';
        break;
      default:
    }

    newState.action = action;
    this.setState(newState);
  }

  setTextValue(textValue = '') {

    //TODO: Actualiza el valor del campo seleccionado
    const selecedField = 'firstName';

    let newState = this.state;
    newState.values[selecedField] = textValue;
    newState.defaultFocus = false;
    this.setState(newState);
  }

  setSelectedImage(imageValue = '') {

    let newState = this.state;
    newState.selectedImage = imageValue;
    this.setState(newState);

  }

  setImageValue(imageValue = '') {

    let newState = this.state;
    newState.values.userImage = imageValue;
    newState.selectedImage = '';
    this.setState(newState);

  }

  updateCurrentPage(value) {
    let newState = this.state;
    newState.avatars.currentPage += value;
    this.setState(newState);
  }

  setIsLoading(value) {
    this.setState({ isLoading: value });
  }

  onFieldError(errors) {

    let newErrors = this.state.errors;
    Object.keys(newErrors).map(propName => {

      newErrors[propName] = '';

      let errorField = errors.filter((err) => {
        return err.name == propName
      });

      if (errorField && errorField[0]) {
        newErrors[propName] = errorField[0].error;
      }

    });

    this.setState({
      ...this.state,
      errors: newErrors
    });
  }

  getFields() {
    return [{
      name: 'firstName',
      value: this.state.values.firstName,
      regExp: /^(.){2,}$/,
      hasError: this.state.errors.firstName != '',
      error: this.state.errors.firstName
    }, {
      name: 'userImage',
      value: this.state.values.userImage,
      regExp: /^(.)*$/,
      hasError: this.state.errors.userImage != '',
      error: this.state.errors.userImage
    }];
  }

  getItems(component) {

    let clickHandler = null;

    switch (component) {
      case constant.START:
        clickHandler = (item) => {
          if (!ProfileReadCache.getEnableClick()) {
            return;
          }

          store.dispatch(setProfileData({
            profile: item.data
          }));

          const userhash = item.data.user_hash;

          this.login({
            userhash,
            includpaywayprofile: 'true'
          });
        };
        break;
      case constant.ADD_PROFILE:
        clickHandler = () => { };
        break;
      case constant.SELECT_PROFILE:
        clickHandler = () => { };
        break;
      case constant.ADMIN_PROFILE:
        clickHandler = (item) => {
          this.setAction(constant.EDIT_PROFILE, item.data);
        };
        break;
      case constant.EDIT_PROFILE:
        clickHandler = () => { };
        break;
      case constant.COMPLETE_PROFILE:
        clickHandler = () => {
          this.setAction(component);
        };
        break;
      default:
        clickHandler = () => { };
        break;
    }

    let members = (this.state.data && this.state.data.members) || [];

    let items = members.map((member) => {

      return {
        name: member.username,
        imgSrc: member.user_image,
        clickHandler,
        data: member,
      }
    });

    return items;
  }

  getComponent() {

    let maxMembers = this.state.data.maxMembers;

    let props = {
      onSetAction: this.setAction,
      onFieldError: this.onFieldError,
      setTextValue: this.setTextValue,
      sendMetricProfile: this.sendMetricProfile,
      maxMembers,
    };

    switch (this.state.action) {
      case constant.START:
        Utils.addPageAction('perfiles');
        props.items = this.getItems(this.state.action);
        return <Start props={props} />;
      case constant.ADD_PROFILE:

        const user = store.getState().user;

        props.user_token = user.user_token;
        props.fields = this.getFields();
        props.createProfile = this.createProfile;
        props.defaultFocus = this.state.defaultFocus;

        return <Add props={props} />;
      case constant.SELECT_PROFILE:
        props.items = this.state.avatars.items;
        props.setImageValue = this.setImageValue;
        props.setSelectedImage = this.setSelectedImage;
        props.formFrom = this.state.formFrom;
        props.selectedImage = this.state.selectedImage;
        props.currentPage = this.state.avatars.currentPage;
        props.updateCurrentPage = this.updateCurrentPage;
        return <Select props={props} />;
      case constant.ADMIN_PROFILE:
        props.items = this.getItems(this.state.action);
        return <Admin props={props} />;
      case constant.EDIT_PROFILE:
        props.fields = this.getFields();
        props.showWarning = this.showWarning;
        props.data = this.state.editData;
        props.updateProfile = this.updateProfile;
        props.defaultFocus = this.state.defaultFocus;
        return <Edit props={props} />;
      case constant.COMPLETE_PROFILE:
        props.updateProfile = this.updateProfile;
        props.fields = this.getFields();
        props.data = this.state.editData;
        props.defaultFocus = this.state.defaultFocus;
        return <Complete props={props} />;
      default:
        return null;
    }
  }

  showWarning(data) {

    const buttons = [
      {
        content: Translator.get('delete_profile_warn_msg_no_btn', 'No, volver'),
        props: {},
      },
      {
        content: Translator.get('delete_profile_warn_msg_yes_btn', 'Si, eliminar'),
        props: {
          onClick: (e) => {

            const user = store.getState().user;

            this.deleteProfile({
              gamification_id: data.gamification_id,
              user_token: user.user_token
            });

          },
        },
      },

    ];

    const contentModal = Translator.get('delete_profile_warn_msg_body', 'El historial de este perfil, incluido Mis Contenidos se eliminará definitivamente, por lo que no tendrás acceso a ellos despúes.');
    const asset = Asset.get('ic_delete_profile_warning', '/images/alerta.png');
    const title = Translator.get('delete_profile_title_warn_msg_title', '¿Eliminar perfil?');

    const modal = {
      modalType: MODAL_GENERIC,
      modalProps: {
        content: contentModal,
        asset,
        title,
        buttons,
        buttonsAlign: 'horizontal'
      }
    };

    store.dispatch(showModal(modal));
  }


  sendMetricProfile(metric) {

    this.props.setMetricsEvent({
      hitType: metric.event,
      eventCategory: metric.category,
      eventAction: metric.action,
      eventLabel: metric.label,
    });

    this.props.setMetricsEvent({ type: 'executor' });

  }

  sendDimension() {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    this.props.setMetricsEvent(payload);
    this.props.setMetricsEvent({ type: 'executor' });
  }

  render() {
    return (
      this.state.isLoading ?
        <Spinner visible={true} />
        :
        <div className='main profile'>
          {this.getComponent(this.state.data)}
        </div>
    );
  }
}


export default connect(null, { setMetricsEvent })(Profile)



// WEBPACK FOOTER //
// ./src/containers/Profile/index.jsx